import React from "react";
import { Slide } from "react-reveal";
const PageHero = (props) => {
  return (
    <section className={props.classes}>
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="page-hero section-height-300 centered">
              <div className=" centered-inner">
                <Slide top>
                  <div className="title-container">
                    <h1 className={props.titleClasses}>{props.title}</h1>
                  </div>
                </Slide>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
